import { css } from "@emotion/react";

export const root = css({
  height: "auto",
  margin: "-10px", // compensate reserved pixels in inner
});

export const inner = css({
  padding: "10px",
  // reserve space for outlines, button counts, etc.
  // to avoid having half of it cut off by the parent container
  // https://link340.lcube-server.de/exonn-erp2/erp2-frontend/-/issues/49#note_22152
});

export const createNewRecordButton = css({
  flexShrink: 0,
});

export const createNewRecordButtonIcon = css({ display: "flex" });
